import { createFileRoute } from "@tanstack/react-router";
import { OG_IMAGE, absolute, hreflangLinks } from "@/lib/site";
import { breadcrumbList } from "@/lib/schema";
import { IndustriesContent } from "@/components/IndustriesContent";

const TITLE = "القطاعات التي نخدمها — شهادات الآيزو | عراق سيرت";
const DESC =
  "خبرة عراق سيرت في شهادات الآيزو عبر قطاعات النفط والغاز والإنشاءات والقطاع الحكومي والتصنيع، لتأهيل الشركات العراقية للمناقصات والعقود الكبرى.";

export const Route = createFileRoute("/ar/industries/")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:url", content: absolute("/ar/industries") },
      { property: "og:image", content: OG_IMAGE },
      { property: "og:locale", content: "ar_IQ" },
      { name: "twitter:image", content: OG_IMAGE },
    ],
    links: [
      { rel: "canonical", href: absolute("/ar/industries") },
      ...hreflangLinks("/industries"),
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(
          breadcrumbList([
            { name: "الرئيسية", path: "/ar" },
            { name: "قطاعات العمل", path: "/ar/industries" },
          ]),
        ),
      },
    ],
  }),
  component: IndustriesContent,
});
